import React, { useEffect, useState } from "react";
import { config } from "./config";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Notification from "./firebase/Notification";

export default function Login() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  // Handle input change
  const handleInputChange = (event) => {
    const input = event.target.value;

    // Allow only digits
    const digitsOnly = input.replace(/\D/g, "");

    if (digitsOnly.length <= 10) {
      setPhoneNumber(digitsOnly);
      setError(""); // Clear error if within limit
    } else {
      setError("Phone number must be 10 digits only.");
      setSnackbarMessage("Phone number can't be more than 10 digits.");
      setSnackbarOpen(true);
    }
  };

  const navigate = useNavigate();



  const handleContinue = async () => {
    if (!phoneNumber) {
      setError("Phone number is required");
      return;
    }

    setLoading(true);
    setError(""); // Reset any previous errors

    try {
      // Replace this with your actual token retrieval logic
      // const token = localStorage.getItem("authToken"); // or wherever your token is stored
      const token = localStorage.getItem("device_token");

      const response = await fetch(
        `${config.api_base}api/v2/sending_otp/${phoneNumber}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }), // Send token
        }
      );

      const data = await response.json();
      localStorage.setItem("phoneNumber", phoneNumber);

      if (response.ok && data.success) {
        console.log(data.message);
        // setSnackbarMessage(data.message);
        setSnackbarOpen(true);

        // Navigate after a short delay
        setTimeout(() => {
          navigate("/verify"); // replace with your actual path
        }, 2000);
      } else {
        setError("Failed to send OTP. Please try again.");
        setSnackbarMessage(data.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Notification />
      <section
        className="h-100 gradient-form"
        style={{ backgroundColor: "#eee" }}
      >
        <div className="container py-5 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col-xl-10">
              <div className="card rounded-3 text-black">
                <div className="row g-0">
                  <div className="col-lg-6">
                    <div className="card-body p-md-5 mx-md-4">
                      <div className="text-center">
                        <a href="https://adoop.in/" target="_blank">
                          <img
                            src="assets/img/logo/adoop-png.png"
                            style={{ width: "185px" }}
                            alt="logo"
                          />
                        </a>
                        <h6 className="mt-1 mb-5 pb-1">
                          Smart Promotions Start with Adoop
                        </h6>
                      </div>

                      <form className="card p-4">
                        <p className="text-center">
                          Please login to your account
                        </p>
                        <div className="form-outline mb-4">
                          <label
                            className="form-label"
                            htmlFor="form2Example11"
                          >
                            Phone number{" "}
                          </label>
                          <input
                            type="text"
                            id="form2Example11"
                            className="form-control"
                            placeholder="Enter your phone number"
                            value={phoneNumber}
                            onChange={handleInputChange}
                            maxLength={10}
                            style={{border:"1px solid #ced4da"}}
                          />
                        </div>
                        <div className="text-center pt-1 mb-2 pb-1">
                          <button
                            className="btn btn-block fa-lg login-btn btn-2 mb-3 validate"
                            type="button"
                            onClick={handleContinue}
                            disabled={loading}
                          >
                            {loading ? "Processing..." : "Continue"}
                          </button>
                        </div>
                       
                        <div className="d-flex align-items-center justify-content-center pb-4">
                          <h6 className="mb-0 me-2" style={{fontSize:"16px"}}>
                            Install Adoop – Let’s Go
                          </h6>
                          {/* <a href="https://play.google.com/store/apps/details?id=com.tes.shoponmobile.promotions.adoop&amp;pcampaignid=web_share"
                                                className="social btn mx-2" target="_blank" contentEditable="false"
                                                style={{cursor: "pointer"}}><img src="assets/img/social/playstore (1).png"
                                                    className="img-fluid" alt="playstore"
                                                    style={{height:"26px", width:"26px"}}/></a>
                                            <a href="https://apps.apple.com/in/app/adoop/id6739332196"
                                                className="social btn" target="_blank" contentEditable="false" style={{cursor: "pointer"}}><svg
                                                    xmlns="http://www.w3.org/2000/svg" width="26" height="26"
                                                    fill="currentColor" className="bi bi-apple" viewBox="0 0 16 16">
                                                    <path
                                                        d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282">
                                                    </path>
                                                    <path
                                                        d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282">
                                                    </path>
                                                </svg></a> */}
                          <a
                            href="https://play.google.com/store/apps/details?id=com.tes.shoponmobile.promotions.adoop&amp;pcampaignid=web_share"
                            className="social btn mx-2"
                            target="_blank"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src="assets/img/social/playstore (1).png"
                              className="img-fluid"
                              alt="playstore"
                              style={{ height: "26px", width: "26px" }}
                            />
                          </a>
                          <a
                            href="https://apps.apple.com/in/app/adoop/id6739332196"
                            className="social btn"
                            target="_blank"
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="26"
                              height="26"
                              fill="#454545"
                              className="bi bi-apple"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
                            </svg>
                          </a>
                          &nbsp;
                        </div>
                      </form>

                      {/* <Snackbar
                        open={snackbarOpen}
                        autoHideDuration={2000}
                        onClose={() => setSnackbarOpen(false)}
                        message={snackbarMessage}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }} // <-- This is key
                      >
                        <Alert
                          severity="error"
                          onClose={() => setSnackbarOpen(false)}
                        >
                          {snackbarMessage}
                        </Alert>
                      </Snackbar> */}
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-center gradient-custom-2">
                    <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                      <h4 className="mb-4">Your Promotion Partner – Adoop</h4>
                      <p
                        style={{ textAlign: "justify" }}
                        className="medium mb-0"
                      >
                        Your brand deserves more than just visibility — it
                        deserves results. Adoop is your trusted promotion
                        partner, built to help businesses scale through smart,
                        targeted, and impactful campaigns.
                        <br />
                        Developed by The{" "}
                        <a
                          href="https://techexponentsystem.com/"
                          className="text-white"
                          target="_blank"
                        >
                          <b>Tech Exponent System </b>
                        </a>{" "}
                        Team, we’re redefining how brands connect with
                        customers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
